import React, { useState, useEffect } from "react";

import * as APIModels from "../../../../models";
import {
    AttorneyService,
    PortalConfigurationService,
} from "../../../../services/ClientService";
import MaterialTable, {
    Column,
    EditComponentProps,
} from "@material-table/core";
import { useCallback } from "react";
import CredentialsModal from "../../../queue/components/modals/CredentialsModal";
import { DataService } from "../../../../services/DataService";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";

type OptionType = { label: string; value: string };

export default function ProfileConfigurations({
    attorney,
}: {
    attorney: APIModels.Attorney;
}) {
    const never = "never" as const;
    const [portalConfigurations, setPortalConfigurations] = useState(
        [] as APIModels.PortalConfigurationRequest[]
    );
    const [stateOptions, setStateOptions] = useState<OptionType[]>(
        [] as OptionType[]
    );

    const [selectedId, setSelectedId] = useState("");

    const [modalShow, setModalShow] = useState(false);

    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const refreshData = () => {
        if (attorney.id != "") {
            PortalConfigurationService.getList({
                attorneyId: attorney.id ?? "",
            }).then(
                (resp) => {
                    if (resp.successful === true) {
                        console.log("PortalConfiguration2 " + attorney.id);
                        setPortalConfigurations(
                            resp.data as APIModels.PortalConfigurationRequest[]
                        );
                    } else {
                        console.log("error");
                    }
                },
                (error) => {
                    console.log(error);
                }
            );
        }
    };

    useEffect(() => {
        PortalConfigurationService.getList({
            attorneyId: attorney.id ?? "",
        }).then(
            (resp) => {
                if (resp.successful === true) {
                    setPortalConfigurations(resp.data!);
                } else {
                    console.log("Error");
                }
            },
            (error) => {
                console.log(error);
            }
        );
    }, [attorney]);

    useEffect(() => {
        DataService.getStates().then(
            (resp) => {
                const options = resp
                    .filter((v, _) => {
                        return v.portal !== null && v.portal !== undefined;
                    })
                    .map((v, _) => {
                        return { value: v.portal!, label: v.abbreviation! };
                    });
                setStateOptions(options);
            },
            (error) => {
                console.log(error);
            }
        );
    }, []);

    const getRowId = (rowData: APIModels.PortalConfigurationRequest) => {
        setSelectedId(rowData.id!);
    };

    return (
        <div className="card text-center">
            <CredentialsModal
                show={modalShow}
                portalConfigId={selectedId}
                onClose={() => setModalShow(false)}
            />
            <Snackbar
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
                open={snackbarOpen}
                onClose={() => setSnackbarOpen(false)}
                autoHideDuration={3000}
            >
                <Alert
                    onClose={() => setSnackbarOpen(false)}
                    severity="success"
                    variant="outlined"
                    sx={{ fontSize: "1rem", padding: "12px 20px" }}
                >
                    Auth cookie string cleared successfully
                </Alert>
            </Snackbar>
            <div className="card-body">
                <div style={{ maxWidth: "100%", zIndex: -1 }}>
                    <MaterialTable
                        columns={[
                            {
                                title: "ID",
                                field: "id",
                                editable: never,
                            },
                            {
                                title: "State",
                                field: "state",
                            },
                            {
                                title: "State Portal",
                                field: "portalIdentifier",
                                render: (data, _) => {
                                    const portals = stateOptions.filter(
                                        (opt) => {
                                            return opt.label === attorney.state;
                                        }
                                    );
                                    // ,
                                    let portal: string;
                                    if (data.portalIdentifier === "GA") {
                                        portal = "https://peachcourt.com/";
                                    } else if (data.portalIdentifier === "GO") {
                                        portal =
                                            "https://georgia.tylertech.cloud/OfsWeb/";
                                    } else if (portals.length === 1) {
                                        portal = portals[0].value;
                                    } else {
                                        portal = "Not Configured";
                                    }
                                    return (
                                        <a
                                            className="btn btn-primary"
                                            href={portal}
                                            target="_blank"
                                        >
                                            Go to Portal
                                        </a>
                                    );
                                },
                            },
                            {
                                title: "Username",
                                field: "username",
                            },
                            {
                                title: "Password",
                                field: "password",
                            },
                            {
                                title: "PaymentToken",
                                field: "paymentToken",
                            },
                            {
                                title: "CVV",
                                field: "cvv",
                            },
                            {
                                title: "DisplayName",
                                field: "displayName",
                            },
                            {
                                title: "2FA Code",
                                field: "twoFactorCode",
                            },
                        ]}
                        data={portalConfigurations}
                        title="Portal Configurations"
                        actions={[
                            {
                                icon: "library_add",
                                tooltip: "Show UserName/Password",
                                onClick: (event, rowData) => {
                                    getRowId(
                                        rowData as APIModels.PortalConfigurationRequest
                                    ),
                                        setModalShow(true);
                                },
                            },
                            {
                                icon: "lock_reset",
                                tooltip: "Clear Credentials",
                                onClick: (event, rowData) => {
                                    const row =
                                        rowData as APIModels.PortalConfigurationRequest;
                                    PortalConfigurationService.clearCredentials(
                                        {
                                            portalConfigId: row.id ?? "",
                                        }
                                    ).then(
                                        () => {
                                            setSnackbarOpen(true);
                                            refreshData();
                                        },
                                        (error) => console.log(error)
                                    );
                                },
                            },
                        ]}
                        editable={{
                            onRowAdd: (newData) =>
                                new Promise((resolve, reject) => {
                                    PortalConfigurationService.add({
                                        attorneyId: attorney.id ?? "",
                                        body: newData!,
                                    }).then(
                                        (resp) => {
                                            refreshData();
                                            resolve(null);
                                        },
                                        (error) => {
                                            console.log(error);
                                            resolve(null);
                                        }
                                    );
                                    resolve(null);
                                }),
                            onRowUpdate: (newData, oldData) =>
                                new Promise((resolve, reject) => {
                                    PortalConfigurationService.update({
                                        portalConfigId: oldData?.id ?? "",
                                        body: newData!,
                                    }).then(
                                        (resp) => {
                                            refreshData();
                                            resolve(null);
                                        },
                                        (error) => {
                                            console.log(error);
                                            resolve(null);
                                        }
                                    );
                                    resolve(null);
                                }),
                            onRowDelete: (oldData) =>
                                new Promise((resolve, reject) => {
                                    PortalConfigurationService.delete({
                                        id: oldData.id ?? "",
                                    }).then(
                                        (resp) => {
                                            refreshData();
                                            resolve(null);
                                        },
                                        (error) => {
                                            console.log(error);
                                            resolve(null);
                                        }
                                    );
                                    resolve(null);
                                }),
                        }}
                    />
                </div>
            </div>
        </div>
    );
}
